import FuseUtils from '@fuse/utils/FuseUtils';
import axios from 'api';
import jwtDecode from 'jwt-decode';
import { getCurrentApiUrl } from 'app/helpers';
import i18n from 'i18next';
// import { showMessage } from 'app/store/actions/fuse';
/* eslint-disable camelcase */

class JwtService extends FuseUtils.EventEmitter {
  init() {
    this.setInterceptors();
    this.handleAuthentication();
  }

  setInterceptors = () => {
    axios.interceptors.response.use(
      response => {
        return response;
      },
      err => {
        return new Promise((resolve, reject) => {
          // if (err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
          // 	// if you ever get an unauthorized response, logout the user
          // 	this.emit('onAutoLogout', err.response.data.message);
          // 	this.setSession(null);
          // }
          throw err;
        });
      }
    );
  };

  handleAuthentication = () => {
    const access_token = this.getAccessToken();

    if (!access_token) {
      this.emit('onNoAccessToken');

      return;
    }

    if (this.isAuthTokenValid(access_token)) {
      this.setSession(access_token);
      this.emit('onAutoLogin', true);
    } else {
      this.setSession(null);
      this.emit('onAutoLogout', i18n.t('session.session_expired'));
    }
  };

  createUser = data => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/auth/register', data)
        .then(response => {
          if (response.data?.user) {
            this.setSession(response.data.access_token);
            resolve(response.data?.user);
          } else {
            reject(response.data?.error);
          }
        })
        .catch(err => err);
    });
  };

  signInWithEmailAndPassword = (email, password, recaptcha) => {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${getCurrentApiUrl()}/auth/`,
          {
            data: {
              email,
              password,
              recaptcha
            }
          },
          {
            withCredentials: true // Ajoute Credentials pour envoyer les cookies
          }
        )
        .then(response => {
          if (response.data.access_token) {
            this.setSession(response.data.access_token);
            resolve();
          } else {
            this.setSession(null);
            reject(response.data.error);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  };

  signInWithToken = navigate => {
    return new Promise((resolve, reject) => {
      const owner = JSON.parse(localStorage.getItem('owner'));

      axios
        .post(
          `${getCurrentApiUrl()}/auth/access-token?is_interpreted=${Boolean(
            owner?.access_token
          )}`,
          {
            data: {
              access_token: this.getAccessToken()
            }
          }
        )
        .then(response => {
          if (response.data?.user) {
            // if accept_cgu is NULL redirect to /terms
            if (!response.data?.user.accept_cgu) {
              localStorage.setItem('user', JSON.stringify(response.data?.user));
              navigate('/terms');
            }
            this.setSession(response.data?.access_token);
            resolve(response.data?.user);
          } else {
            reject(response.data?.error);
          }
        });
    });
  };

  updateUserData = user => {
    return axios.post('/api/auth/user/update', {
      user
    });
  };

  setSession = access_token => {
    if (access_token) {
      localStorage.setItem('jwt_access_token', access_token);
      axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;
    } else {
      localStorage.removeItem('jwt_access_token');
      delete axios.defaults.headers.common.Authorization;
    }
  };

  logout = () => {
    this.setSession(null);
  };

  isAuthTokenValid = access_token => {
    if (!access_token) {
      return false;
    }
    const decoded = jwtDecode(access_token);
    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
      console.warn('access token expired');
      // Redirection dashboard
      window.location.href = '/login';
      return false;
    }

    return true;
  };

  getAccessToken = () => {
    return window.localStorage.getItem('jwt_access_token');
  };
}

const instance = new JwtService();

export default instance;
